module.exports = __webpack_public_path__ + "img/company1.447892f1.jpg";